enum Portal {
    Buyer = 'Buyer',
    Supplier = 'Supplier',
    Sales = 'Sales',
    CustomerService = 'CustomerService',
}

export default Portal;
